module.exports = __webpack_public_path__ + "img/Id.dd555b86.svg";